import React from 'react';
import {SubmissionDto, SubmissionApi} from '../../scaffold';
import Text from 'antd/lib/typography/Text';
import Flex from '../Flex';
import {Space} from 'antd';
import useAuth from '../../utils/AuthContext';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function SubmissionPapers(props: {submission: SubmissionDto; isJudgeVersion: boolean; refresh: () => any; readonly: boolean}) {
  const list = props.isJudgeVersion ? props.submission.judgePapers : props.submission.supervisorPapers;
  const deleteState = useOpenApiFpRequest(SubmissionApi, SubmissionApi.prototype.submissionDeletePaperPost);
  const auth = useAuth();
  return (
    <div style={{background: 'rgba(217,217,217,0.6)', padding: 10}}>
      {list?.map(paper => (
        <Flex key={paper.id} className={'m-b-4'} style={{width: 500}} justify={'space-between'}>
          <Text strong>{paper.name}</Text>
          <Space style={{flexShrink: 0}}>
            <a href={paper.url || ''} target={'_blank'}>
              下载
            </a>
            {auth.currentUser?.id === props.submission.userId && !props.readonly && (
              <a
                onClick={() =>
                  deleteState
                    .request({submissionDeletePaperModel: {id: props.submission.id || 0, paperId: paper.id || 0}})
                    .then(props.refresh)
                    .catch(CommonApiErrorHandler)
                }>
                删除
              </a>
            )}
          </Space>
        </Flex>
      ))}
    </div>
  );
}
